import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useAllStores from "hooks/useCurrentUserStores";
import useGetItemsByStoreId from "../useGetItemsByStoreId";
import usePauseItem from "../usePauseItem";
import PauseModalContainer from "../Components/PauseModal";
import AppContainer from "components/ui/AppContainer";
import AppPaginatedTable from "components/ui/AppPaginatedTable";
import AppSearchInput from "components/ui/AppSearchInput";
import AppSelect from "components/ui/AppSelect.jsx";
import PlayPause from "../Components/PlayPause";
const Inventory = () => {
  //local state
  const { t } = useTranslation();

  const [state, setState] = useState({
    currentStoreId: null,
    items: [],
    loading: false,
  });
  //custom hooks
  const { stores, loading } = useAllStores();
  const [selectedStore, setSelectedStore] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const updateState = (key, val) =>
    setState((state) => ({ ...state, [key]: val }));
  const getItemsByStoreId = useGetItemsByStoreId(updateState);

  const handleChange = (val) => {
    if (val) {
      getItemsByStoreId(val);
      updateState("currentStoreId", val);
      setSelectedStore(val);
    }
  };

  React.useEffect(() => {
    if (selectedStore || !stores?.length) return;
    handleChange(stores[0]?.value);
  }, [stores, selectedStore]);

  const [PauseModel, setPauseModel] = useState({
    open: false,
    modifier: null,
    deafaultOption: {
      value: 6,
      unit: "hours",
      duration: "6_HOURS",
    },
  });

  const setPauseModalState = (key, val) => {
    setPauseModel((prevState) => ({
      ...prevState,
      [key]: val,
    }));
  };

  const { playPauseItem, handlePlayPause } = usePauseItem({
    setPauseModalState,
    updateState,
    getItemsByStoreId,
    state,
  });

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const closeModal = () => {
    setPauseModalState("modifier", null);
    setPauseModalState("deafaultOption", {
      value: 6,
      unit: "hours",
      duration: "6_HOURS",
    });
    setPauseModalState("open", false);
  };
  const ItemsListArr = React.useMemo(() => {
    if (!searchTerm) return state?.items;

    let searchTermLower = searchTerm?.toLowerCase()?.trim();

    return state?.items.filter((item) =>
      item?.baseLanguage?.title?.toLowerCase()?.includes(searchTermLower)
    );
  }, [state?.items, searchTerm]);

  React.useEffect(() => {
    setCurrentPage(1);
  }, [selectedStore, searchTerm]);

  const isLoading = state.loading || loading;
  const columns = [
    {
      title: t("Item"),
      dataIndex: "baseLanguage",
      key: "item",
      render: (baseLanguage, row, index) => {
        return baseLanguage?.title;
      },
    },
    {
      title: t("Availability"),
      dataIndex: "itemInfo",
      key: "availability",
      render: (val, row, index) => {
        return (
          <PlayPause
            {...{
              rowData: row,
              state,
              handlePlayPause,
            }}
          />
        );
      },
    },
    {
      title: t("Price"),
      dataIndex: "price",
      key: "price",
      render: (price, row, index) => {
        return (
          <span className="whitespace-nowrap">{`${t(
            "AED"
          )}${"  "} ${price}`}</span>
        );
      },
    },
  ];
  return (
    <AppContainer
      title={t("Operations")}
      subTitle={t(
        "Select store from the dropdown to play/pause inventory for particular store"
      )}
      loading={isLoading}
      containerProps={{ className: "overflow-y-hidden" }}
    >
      <div className="my-3 flex flex-col md:flex-row md:items-end justify-between">
        <div className="w-full md:w-1/4">
          <AppSelect
            label={t("Select store")}
            options={stores}
            value={selectedStore}
            onChange={(v) => handleChange(v)}
          />
        </div>
        <div className="w-full md:w-1/4 my-3 md:my-0">
          <AppSearchInput
            searchTerm={searchTerm}
            onInput={(e) => setSearchTerm(e.target.value)}
            placeholder={t("Search by item name")}
          />
        </div>
      </div>
      <AppPaginatedTable
        columns={columns}
        data={ItemsListArr}
        clientSidePagination={true}
        pageSize={pageSize}
        page={currentPage}
        total={ItemsListArr?.length}
        onPageChange={(page, pageSize) => handlePageChange(page, pageSize)}
      />
      <PauseModalContainer
        heading={t("Pause item")}
        title1={PauseModel?.modifier?.baseLanguage?.title}
        title2="Select a time frame where item will be paused. After this time, it'll be automatically resumed"
        isLoading={isLoading}
        {...{ PauseModel, closeModal, setPauseModalState, playPauseItem }}
      />
    </AppContainer>
  );
};
export default Inventory;
